import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEventsTicketingCheckoutServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/events-ticketing-v1-proxy',
        destPath: '/api',
      },
    ],
    _: [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definition',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/events-ticketing-v1-proxy/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/events-ticketing-v1-proxy/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    '*.pub.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'api._base_domain_': [
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'editor-flow.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveWixEventsTicketingOrderManagementUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'events._base_domain_': [
      {
        srcPath: '',
        destPath: '',
      },
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
    ],
    'www.wixevents.com': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/api',
        destPath: '/api',
      },
      {
        srcPath: '/viewEvent',
        destPath: '/viewEvent',
      },
      {
        srcPath: '/viewRsvpDashboard',
        destPath: '/viewRsvpDashboard',
      },
      {
        srcPath: '/viewOrderDashboard',
        destPath: '/viewOrderDashboard',
      },
      {
        srcPath: '/viewSummarySubscription',
        destPath: '/viewSummarySubscription',
      },
      {
        srcPath: '/check-in',
        destPath: '/check-in',
      },
      {
        srcPath: '/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/export',
        destPath: '/export',
      },
      {
        srcPath: '/tickets',
        destPath: '/tickets',
      },
      {
        srcPath: '/payment-redirect',
        destPath: '/payment-redirect',
      },
      {
        srcPath: '/admin',
        destPath: '/admin',
      },
      {
        srcPath: '/ticket',
        destPath: '/ticket',
      },
      {
        srcPath: '/media',
        destPath: '/media',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/wix-events-web',
        destPath: '',
      },
    ],
    'events.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/events',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-events-web/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/events',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v2/events',
        destPath: '/v2/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/events',
        destPath: '/v1/bulk/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/events/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/events/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/events/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/events/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/events/v1/bulk/events',
        destPath: '/v1/bulk/events',
      },
      {
        srcPath: '/events/v1/reports',
        destPath: '/v1/reports',
      },
      {
        srcPath: '/events/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/events/v1/web',
        destPath: '/v1/web',
      },
      {
        srcPath: '/events/v2/tickets',
        destPath: '/v2/tickets',
      },
      {
        srcPath: '/events/v2/events',
        destPath: '/v2/events',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/events/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/events/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/events/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/events/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/events/v2/events',
        destPath: '/v2/events',
      },
      {
        srcPath: '/events/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
    ],
    'api._base_domain_': [
      {
        srcPath: '/events/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/events/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/events/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/events/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/events/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/events/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    _: [
      {
        srcPath: '/_api/wix-events-web/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/events/v2/events',
        destPath: '/v2/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    '*.pub.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'editor-flow.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_events_orders';

/** Retrieves a list of orders, including ticket data. */
export function listOrders(payload: object): RequestOptionsFactory<any> {
  function __listOrders({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'GET' as any,
      methodFqn: 'wix.events.ticketing.OrderManagement.ListOrders',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingOrderManagementUrl({
        protoPath: '/v1/orders',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'orders.created' },
              { path: 'orders.updated' },
              { path: 'orders.checkoutForm.inputValues.dateTime' },
              { path: 'orders.tickets.checkIn.created' },
              { path: 'orders.tickets.checkIn.checkInCanceledDate' },
              { path: 'orders.tickets.guestDetails.form.inputValues.dateTime' },
              {
                path: 'orders.paymentDetails.transaction.scheduledActionExecutionDate',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'orders.checkoutForm.inputValues.number' },
              {
                path: 'orders.checkoutForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'orders.checkoutForm.inputValues.address.address.geocode.longitude',
              },
              { path: 'orders.tickets.guestDetails.form.inputValues.number' },
              {
                path: 'orders.tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'orders.tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listOrders;
}

/**
 * Retrieves an order, including ticket data.
 * <!--
 * >The fieldsets in this function are restricted and only run if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 */
export function getOrder(payload: object): RequestOptionsFactory<any> {
  function __getOrder({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'GET' as any,
      methodFqn: 'wix.events.ticketing.OrderManagement.GetOrder',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingOrderManagementUrl({
        protoPath: '/v1/events/{eventId}/orders/{orderNumber}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'order.created' },
              { path: 'order.updated' },
              { path: 'order.checkoutForm.inputValues.dateTime' },
              { path: 'order.tickets.checkIn.created' },
              { path: 'order.tickets.checkIn.checkInCanceledDate' },
              { path: 'order.tickets.guestDetails.form.inputValues.dateTime' },
              {
                path: 'order.paymentDetails.transaction.scheduledActionExecutionDate',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'order.checkoutForm.inputValues.number' },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.longitude',
              },
              { path: 'order.tickets.guestDetails.form.inputValues.number' },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getOrder;
}

/** Updates an order. */
export function updateOrder(payload: object): RequestOptionsFactory<any> {
  function __updateOrder({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fields' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'expires' },
          { path: 'checkoutForm.inputValues.dateTime' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'checkoutForm.inputValues.number' },
          { path: 'checkoutForm.inputValues.address.address.geocode.latitude' },
          {
            path: 'checkoutForm.inputValues.address.address.geocode.longitude',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.ticketing.OrderManagement.UpdateOrder',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingOrderManagementUrl({
        protoPath: '/v1/events/{eventId}/orders/{orderNumber}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'order.created' },
              { path: 'order.updated' },
              { path: 'order.checkoutForm.inputValues.dateTime' },
              { path: 'order.tickets.checkIn.created' },
              { path: 'order.tickets.checkIn.checkInCanceledDate' },
              { path: 'order.tickets.guestDetails.form.inputValues.dateTime' },
              {
                path: 'order.paymentDetails.transaction.scheduledActionExecutionDate',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'order.checkoutForm.inputValues.number' },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.longitude',
              },
              { path: 'order.tickets.guestDetails.form.inputValues.number' },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateOrder;
}

/** Archives multiple orders. */
export function bulkUpdateOrders(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateOrders({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fields' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.ticketing.OrderManagement.BulkUpdateOrders',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingOrderManagementUrl({
        protoPath: '/v1/events/{eventId}/orders',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'orders.created' },
              { path: 'orders.updated' },
              { path: 'orders.checkoutForm.inputValues.dateTime' },
              { path: 'orders.tickets.checkIn.created' },
              { path: 'orders.tickets.checkIn.checkInCanceledDate' },
              { path: 'orders.tickets.guestDetails.form.inputValues.dateTime' },
              {
                path: 'orders.paymentDetails.transaction.scheduledActionExecutionDate',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'orders.checkoutForm.inputValues.number' },
              {
                path: 'orders.checkoutForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'orders.checkoutForm.inputValues.address.address.geocode.longitude',
              },
              { path: 'orders.tickets.guestDetails.form.inputValues.number' },
              {
                path: 'orders.tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'orders.tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateOrders;
}

/**
 * Confirms an order.
 *
 *
 * This function changes order status from `INITIATED`, `PENDING`, `OFFLINE_PENDING` to `PAID`.
 * Confirming orders with `INITIATED` or `PENDING` status triggers an email with the tickets to the buyer (and to additional guests, if provided).
 */
export function confirmOrder(payload: object): RequestOptionsFactory<any> {
  function __confirmOrder({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'POST' as any,
      methodFqn: 'wix.events.ticketing.OrderManagement.ConfirmOrder',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingOrderManagementUrl({
        protoPath: '/v1/events/{eventId}/orders/confirm',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'orders.created' },
              { path: 'orders.updated' },
              { path: 'orders.checkoutForm.inputValues.dateTime' },
              { path: 'orders.tickets.checkIn.created' },
              { path: 'orders.tickets.checkIn.checkInCanceledDate' },
              { path: 'orders.tickets.guestDetails.form.inputValues.dateTime' },
              {
                path: 'orders.paymentDetails.transaction.scheduledActionExecutionDate',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'orders.checkoutForm.inputValues.number' },
              {
                path: 'orders.checkoutForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'orders.checkoutForm.inputValues.address.address.geocode.longitude',
              },
              { path: 'orders.tickets.guestDetails.form.inputValues.number' },
              {
                path: 'orders.tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'orders.tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __confirmOrder;
}

/**
 * Retrieves a summary of total ticket sales.
 * <!--
 * > Note: This function is restricted and only runs if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 */
export function getSummary(payload: object): RequestOptionsFactory<any> {
  function __getSummary({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'GET' as any,
      methodFqn: 'wix.events.ticketing.OrderManagement.GetSummary',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingOrderManagementUrl({
        protoPath: '/v1/orders/summary',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getSummary;
}

/**
 * Captures authorized payment asynchronously.
 * Eventually order will become paid.
 * For orders with non-authorized payments request will fail.
 */
export function captureAuthorizedPayment(
  payload: object
): RequestOptionsFactory<any> {
  function __captureAuthorizedPayment({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'POST' as any,
      methodFqn:
        'wix.events.ticketing.OrderManagement.CaptureAuthorizedPayment',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingOrderManagementUrl({
        protoPath: '/v1/events/orders/{orderNumber}/capture',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __captureAuthorizedPayment;
}

/**
 * Voids authorized payment asynchronously.
 * Eventually order will become voided.
 * For orders with non-authorized payments request will fail.
 */
export function voidAuthorizedPayment(
  payload: object
): RequestOptionsFactory<any> {
  function __voidAuthorizedPayment({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'POST' as any,
      methodFqn: 'wix.events.ticketing.OrderManagement.VoidAuthorizedPayment',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingOrderManagementUrl({
        protoPath: '/v1/events/orders/{orderNumber}/void',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __voidAuthorizedPayment;
}

/** Retrieves checkout details. */
export function getCheckoutOptions(
  payload: object
): RequestOptionsFactory<any> {
  function __getCheckoutOptions({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'GET' as any,
      methodFqn: 'wix.events.ticketing.CheckoutService.GetCheckoutOptions',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingCheckoutServiceUrl({
        protoPath: '/v1/checkout/options',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getCheckoutOptions;
}

/**
 * Returns tickets available to reserve.
 * <!--
 * > Note: This function is restricted and only runs if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 */
export function listAvailableTickets(
  payload: object
): RequestOptionsFactory<any> {
  function __listAvailableTickets({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'overrideRequestTime' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'GET' as any,
      methodFqn: 'wix.events.ticketing.CheckoutService.ListAvailableTickets',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingCheckoutServiceUrl({
        protoPath: '/v1/checkout/available-tickets',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'definitions.salePeriod.startDate' },
              { path: 'definitions.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listAvailableTickets;
}

/**
 * Returns tickets available to reserve.
 * <!--
 * > Note: The fieldsets in this function are restricted and only run if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 */
export function queryAvailableTickets(
  payload: object
): RequestOptionsFactory<any> {
  function __queryAvailableTickets({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'POST' as any,
      methodFqn: 'wix.events.ticketing.CheckoutService.QueryAvailableTickets',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingCheckoutServiceUrl({
        protoPath: '/v1/checkout/available-tickets/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'definitions.salePeriod.startDate' },
              { path: 'definitions.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryAvailableTickets;
}

/**
 * Reserves tickets for 20 minutes.
 *
 *
 * Reserved tickets are deducted from ticket stock and cannot be bought by another site visitor.
 * When the reservation expires, the tickets are added back to the stock.
 * @deprecated It has been replaced with wix.events.ticketreservations.v1.TicketReservationManagement.CreateTicketReservation(), and will be removed on 2026-03-31.
 */
export function createReservation(payload: object): RequestOptionsFactory<any> {
  function __createReservation({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'overrideRequestTime' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'POST' as any,
      methodFqn: 'wix.events.ticketing.CheckoutService.CreateReservation',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingCheckoutServiceUrl({
        protoPath: '/v1/checkout/reservations',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'expires' },
              { path: 'reservations.ticket.salePeriod.startDate' },
              { path: 'reservations.ticket.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createReservation;
}

/**
 * Cancels ticket reservation and returns tickets to stock.
 * <!--
 * > Note: This function is restricted and only runs if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 * @deprecated It has been replaced with wix.events.ticketreservations.v1.TicketReservationManagement.CancelTicketReservation(), and will be removed on 2026-03-31.
 */
export function cancelReservation(payload: object): RequestOptionsFactory<any> {
  function __cancelReservation({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'DELETE' as any,
      methodFqn: 'wix.events.ticketing.CheckoutService.CancelReservation',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingCheckoutServiceUrl({
        protoPath: '/v1/checkout/reservations/{id}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __cancelReservation;
}

/** Generates a preview of an invoice, including the given coupon or pricing plan. */
export function getInvoice(payload: object): RequestOptionsFactory<any> {
  function __getInvoice({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'POST' as any,
      methodFqn: 'wix.events.ticketing.CheckoutService.GetInvoice',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingCheckoutServiceUrl({
        protoPath: '/v1/checkout/invoices/{reservationId}',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'expires' },
              { path: 'reservations.ticket.salePeriod.startDate' },
              { path: 'reservations.ticket.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getInvoice;
}

/**
 * Checkouts the reserved tickets.
 *
 *
 * Creates an order and associates it with a site visitor contact.
 * Guest details are received from the [Registration Form](https://www.wix.com/velo/reference/wix-events-v2/forms/introduction) input fields.
 *
 * There is a possibility to use a separate ready-made Wix checkout form where the user will be redirected from your non-Wix site or a custom ticket picker created with Velo.
 * To build the checkout form path, get your event base URL by using the [`getEvent()`](https://www.wix.com/velo/reference/wix-events-backend/wixevents/getevent) function and add the following path:
 * `/{{EVENT_PAGE_SLUG}}/{{SLUG}}/ticket-form?reservationId={{YOUR_RESERVATION_ID}}`
 *
 * Example:  `https://johndoe.wixsite.com/weddings/event-details/doe-wedding/ticket-form?reservationId=2be6d34a-2a1e-459f-897b-b4a66e73f69a`
 */
export function checkout(payload: object): RequestOptionsFactory<any> {
  function __checkout({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'overrideRequestTime' },
          { path: 'guests.form.inputValues.dateTime' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'guests.form.inputValues.number' },
          { path: 'guests.form.inputValues.address.address.geocode.latitude' },
          { path: 'guests.form.inputValues.address.address.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'POST' as any,
      methodFqn: 'wix.events.ticketing.CheckoutService.Checkout',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingCheckoutServiceUrl({
        protoPath: '/v1/checkout',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'expires' },
              { path: 'order.created' },
              { path: 'order.updated' },
              { path: 'order.checkoutForm.inputValues.dateTime' },
              { path: 'order.tickets.checkIn.created' },
              { path: 'order.tickets.checkIn.checkInCanceledDate' },
              { path: 'order.tickets.guestDetails.form.inputValues.dateTime' },
              {
                path: 'order.paymentDetails.transaction.scheduledActionExecutionDate',
              },
              { path: 'reservations.ticket.salePeriod.startDate' },
              { path: 'reservations.ticket.salePeriod.endDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'order.checkoutForm.inputValues.number' },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.longitude',
              },
              { path: 'order.tickets.guestDetails.form.inputValues.number' },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __checkout;
}

/**
 * Updates order and tickets.
 *
 *
 * Only applicable for orders with `INITIATED`, `PENDING`, `OFFLINE_PENDING` statuses.
 */
export function updateCheckout(payload: object): RequestOptionsFactory<any> {
  function __updateCheckout({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'guests.form.inputValues.number' },
          { path: 'guests.form.inputValues.address.address.geocode.latitude' },
          { path: 'guests.form.inputValues.address.address.geocode.longitude' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'guests.form.inputValues.dateTime' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.ticketing.CheckoutService.UpdateCheckout',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingCheckoutServiceUrl({
        protoPath: '/v1/checkout/{orderNumber}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'order.created' },
              { path: 'order.updated' },
              { path: 'order.checkoutForm.inputValues.dateTime' },
              { path: 'order.tickets.checkIn.created' },
              { path: 'order.tickets.checkIn.checkInCanceledDate' },
              { path: 'order.tickets.guestDetails.form.inputValues.dateTime' },
              {
                path: 'order.paymentDetails.transaction.scheduledActionExecutionDate',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'order.checkoutForm.inputValues.number' },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.longitude',
              },
              { path: 'order.tickets.guestDetails.form.inputValues.number' },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateCheckout;
}

/** Creates order with payment details already initiated via Cashier Pay API. */
export function posCheckout(payload: object): RequestOptionsFactory<any> {
  function __posCheckout({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.order',
      method: 'POST' as any,
      methodFqn: 'wix.events.ticketing.CheckoutService.PosCheckout',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingCheckoutServiceUrl({
        protoPath: '/v1/pos-checkout',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'expires' },
              { path: 'order.created' },
              { path: 'order.updated' },
              { path: 'order.checkoutForm.inputValues.dateTime' },
              { path: 'order.tickets.checkIn.created' },
              { path: 'order.tickets.checkIn.checkInCanceledDate' },
              { path: 'order.tickets.guestDetails.form.inputValues.dateTime' },
              {
                path: 'order.paymentDetails.transaction.scheduledActionExecutionDate',
              },
              { path: 'reservations.ticket.salePeriod.startDate' },
              { path: 'reservations.ticket.salePeriod.endDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'order.checkoutForm.inputValues.number' },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.checkoutForm.inputValues.address.address.geocode.longitude',
              },
              { path: 'order.tickets.guestDetails.form.inputValues.number' },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'order.tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __posCheckout;
}
